/* eslint-disable jsx-a11y/alt-text */
import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import i18n from "../../i18n/i18n";
import TeamBuildingActivityListItem from "../TeamBuildingActivityListItem/TeamBuildingActivityListItem";
import { HandleMetaTags } from "../../utils/ApiServices";
import axios from "axios";

function TeamBuildingActivities() {
  const [isLoading, setIsLoading] = useState(true);
  const [activities, setActivities] = useState([]);

  const fetchActivities = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        "https://admin.upgrade-skills.com/api/team-building-activities"
      );
      if (response.data && Array.isArray(response.data)) {
        setActivities(response.data);
      } else {
        setActivities([]);
      }
    } catch (error) {
      console.error("Error fetching team building activities:", error);
      setActivities([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchActivities();
    // scroll to the top of the page on mount
    window.scrollTo(0, 0);
    // Call the updateMetaTags function with the dynamic values
    HandleMetaTags(1, 5);
  }, []);

  return (
    <div>
      <div
        className="section page-banner"
        style={{ height: "20rem" }}
        dir="ltr"
      >
        <img
          className="shape-1 animation-round"
          src={process.env.PUBLIC_URL + "/images/shape/shape-8.png"}
        />
        <div className="container">
          <div className="page-banner-content">
            <ul className="breadcrumb">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">Team Building Activities</li>
            </ul>
            <h2 className="title">
              Team Building <span>Activities</span>
            </h2>
          </div>
        </div>
        <div className="shape-icon-box">
          <img
            className="icon-shape-1 animation-left"
            src={process.env.PUBLIC_URL + "/images/shape/shape-5.png"}
          />
          <div className="box-content">
            <div className="box-wrapper">
              <i className="flaticon-badge"></i>
            </div>
          </div>
          <img
            className="icon-shape-2"
            src={process.env.PUBLIC_URL + "/images/shape/shape-6.png"}
          />
        </div>
        <img
          className="shape-3"
          src={process.env.PUBLIC_URL + "/images/shape/shape-24.png"}
        />
        <img
          className="shape-author"
          src={process.env.PUBLIC_URL + "/images/author/author-11.jpg"}
        />
      </div>

      <div className="section pb-5" style={{ marginTop: "-10px" }}>
        <div className="container">
          <div className="courses-wrapper-02" style={{ width: "100%" }}>
            <div className="row">
              {isLoading ? (
                <center>
                  <Spinner animation="border" variant="primary" />
                </center>
              ) : activities.length === 0 ? (
                <p className="p-4">No team building activities found.</p>
              ) : (
                activities.map((activity) => (
                  <TeamBuildingActivityListItem
                    activity={activity}
                    key={activity.id}
                  />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamBuildingActivities;

